module.exports = __webpack_public_path__ + "static/media/npb.46a2a169.png";